import React, { useState } from "react";
import Header from './Header';
import Note from './Note';
import Footer from './Footer';
import CreateArea from "./createArea";

function App() {
    const [notes, setNotes] = useState([]);

    function addNote(newNote) {
        setNotes(prevNotes => [...prevNotes, newNote]);
    }

    function deleteNote(id) {
        setNotes(prevNotes => prevNotes.filter((_, index) => index !== id));
    }

    return (
        <div>
            <Header />
            <CreateArea onAdd={addNote} />
            <div className="notes-container">
                {notes.map((noteItem, index) => (
                    <Note
                        key={index}
                        id={index}
                        title={noteItem.title}
                        content={noteItem.content}
                        onDelete={deleteNote}
                    />
                ))}
            </div>
            <Footer />
        </div>
    );
}

export default App;